/**
 * Created by andrey on 06.09.19.
 */

const CloudsAnimation = cc.Node.extend({
    ctor: function () { 
        this._super();

        this.setLocalZOrder(101);

        const animation = this.animation = new cleverapps.Spine(bundles.main.jsons.episode_clouds_spine_json);
        this.addChild(animation);

        this.inUse = true;
    },

    startLoadAnimation: function (episodeView) {
        this.animation.setAnimation(0, "idle", true);

        this.setVisible(false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => {
                this.visible = episodeView.isRunning() && episodeView.visible;
            })
        ));
    },

    finishLoadAnimation: function (onFinish) {
        this.animation.setAnimation(0, "open", false);
        this.animation.setCompleteListener(() => {
            this.finishAnimation(onFinish);
        });
    },

    finishAnimation: function (onFinish) {
        if (this.inUse) {
            this.inUse = false;
            cleverapps.pool.putInPool(this);

            if (typeof onFinish === "function") {
                onFinish();
            }
        }
    },

    unuse: function () {
        this.animation.visible = false;
        this.animation.setCompleteListener();
        this.animation.setStartVisibleListener(() => {});
        this.removeFromParent(); // if this.removeFromParent(false); then stable crashes in ios - with cleanup ok
    },

    reuse: function () {
        this.inUse = true;
    }
});

CloudsAnimation.factory = function () {
    return cleverapps.pool.hasObject(CloudsAnimation) ? cleverapps.pool.getFromPool(CloudsAnimation) : new CloudsAnimation();
};
